import { render, staticRenderFns } from "./ProductVariantsDelivery.vue?vue&type=template&id=7b4173c0&scoped=true&"
import script from "./ProductVariantsDelivery.vue?vue&type=script&lang=js&"
export * from "./ProductVariantsDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantsDelivery.vue?vue&type=style&index=0&id=7b4173c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4173c0",
  null
  
)

export default component.exports